module.exports = __webpack_public_path__ + "static/media/post-13.ba8f0f95.jpg";